import clsx from "clsx";
import React from "react";

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        "text-[14px] font-semibold uppercase tracking-[0.04em] pt-3.5 relative transition-colors",
        isActive ? "text-primary" : "text-secondary hover:text-secondary",
      )}
    >
      {isActive && (
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-primary"></div>
      )}
      {label}
    </button>
  );
};
